import React, { useState } from 'react'
import { useFavorites } from 'shared/api/favorites'
import AnimatedBackground from 'shared/components/animated-background/background'
import NoFavorites from 'shared/components/favorite/no-favorites'
import Grid from 'shared/components/grid'
import withLocationState from 'shared/components/with-location-state'
import useAsyncEffect from 'shared/hooks/use-async-effect'
import styled from 'styled-components'

const Background = styled.div`
    height: 100%;
    left: 0;
    opacity: 0.8;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: -1;
`

const Favorites = () => {
    const [hasGifs, setHasGifs] = useState<boolean>()
    const fetchGifs = useFavorites()
    const dummyFetchGifs = useFavorites()
    useAsyncEffect(async () => {
        const { data } = await dummyFetchGifs(0)
        setHasGifs(data.length > 0)
    }, [])
    if (hasGifs === undefined) {
        return null
    }
    return hasGifs ? (
        <div>
            <div>
                <div style={{ clear: 'both' }} />
            </div>
            <Grid fetchGifs={fetchGifs} />
        </div>
    ) : (
        <>
            <Background>
                <AnimatedBackground assetUrls={['/static/img/svg/heart.svg']} />
            </Background>
            <NoFavorites />
        </>
    )
}

export default withLocationState(['gifs'])(Favorites)
